{
  "PROFILE_SETTINGS": {
    "LINK": "Impostazioni profilo",
    "TITLE": "Impostazioni profilo",
    "BTN_TEXT": "Aggiorna profilo",
    "DELETE_AVATAR": "Elimina avatar",
    "AVATAR_DELETE_SUCCESS": "L'avatar è stato eliminato con successo",
    "AVATAR_DELETE_FAILED": "C'è un errore durante l'eliminazione dell'avatar, si prega di riprovare",
    "UPDATE_SUCCESS": "Il tuo profilo è stato aggiornato con successo",
    "PASSWORD_UPDATE_SUCCESS": "La tua password è stata modificata con successo",
    "AFTER_EMAIL_CHANGED": "Il tuo profilo è stato aggiornato correttamente, effettua nuovamente l'accesso, siccome le tue credenziali di accesso sono state modificate",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Immagine della firma email",
        "HINT": "Utilizzata nelle firme email. {'{{'}email_signature_picture{'}}'} viene sostituito con l'URL di questa immagine (non un tag immagine) — usalo come sorgente dell'immagine (l'attributo src di un tag img) nella tua firma o nella firma della casella di posta. Se non è impostata, non viene inserito nulla.",
        "DELETE_SUCCESS": "L'immagine della firma email è stata eliminata con successo",
        "DELETE_FAILED": "Si è verificato un errore durante l'eliminazione dell'immagine della firma email, riprova"
      },
      "AVATAR": "Immagine del profilo",
      "ERROR": "Correggi gli errori del modulo",
      "REMOVE_IMAGE": "Rimuovi",
      "UPLOAD_IMAGE": "Carica immagine",
      "UPDATE_IMAGE": "Aggiorna immagine",
      "PROFILE_SECTION": {
        "TITLE": "Profilo",
        "NOTE": "Il tuo indirizzo email è la tua identità e viene utilizzato per l'accesso."
      },
      "SEND_MESSAGE": {
        "TITLE": "Scorciatoia per inviare messaggi",
        "NOTE": "Puoi selezionare una scorciatoia (Enter oppure Cmd/Ctrl+Enter) in base alle tue preferenze di scrittura.",
        "UPDATE_SUCCESS": "Le tue impostazioni sono state aggiornate con successo",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Invia i messaggi premendo il tasto Enter invece di cliccare sul pulsante di invio."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Invia i messaggi premendo Cmd/Ctrl + Enter invece di cliccare sul pulsante di invio."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interfaccia",
        "NOTE": "Personalizza l'aspetto del tuo dashboard.",
        "FONT_SIZE": {
          "TITLE": "Dimensione del carattere",
          "NOTE": "Regola la dimensione del testo nel dashboard in base alle tue preferenze.",
          "UPDATE_SUCCESS": "Le impostazioni del carattere sono state aggiornate con successo",
          "UPDATE_ERROR": "Si è verificato un errore durante l'aggiornamento delle impostazioni del carattere, riprova",
          "OPTIONS": {
            "SMALLER": "Più piccolo",
            "SMALL": "Piccolo",
            "DEFAULT": "Predefinito",
            "LARGE": "Grande",
            "LARGER": "Più grande",
            "EXTRA_LARGE": "Extra grande"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Lingua della dashboard",
          "NOTE": "Sovrascrivi la lingua dell'account per la tua dashboard. Lascia vuoto per usare il valore predefinito dell'account.",
          "USE_ACCOUNT_DEFAULT": "Usa valore predefinito dell'account",
          "API_SUCCESS": "La lingua della dashboard è stata aggiornata con successo",
          "API_ERROR": "Si è verificato un errore durante l'aggiornamento della lingua della dashboard, riprova"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Lingua dei messaggi",
          "NOTE": "Scegli se visualizzare i messaggi originali o le loro traduzioni",
          "ORIGINAL": "Originale",
          "TRANSLATED": "Tradotto"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportamento di incolla",
          "NOTE": "Scegli come elaborare il contenuto incollato durante la composizione dei messaggi",
          "UPDATE_SUCCESS": "Le tue impostazioni di incolla sono state aggiornate con successo",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Preserva tutta la formattazione",
              "DESCRIPTION": "Mantieni tutta la formattazione incluse tabelle, stili e altri elementi HTML quando incolli contenuto."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Solo testo con link",
              "DESCRIPTION": "Converti in testo semplice ma preserva i link cliccabili quando incolli contenuto."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Solo testo semplice",
              "DESCRIPTION": "Rimuovi tutta la formattazione e converti in testo semplice quando incolli contenuto."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Altezza della casella di risposta",
          "NOTE": "Imposta l'altezza minima della casella di risposta come percentuale dell'altezza dello schermo. Si applica solo alle conversazioni email.",
          "UPDATE_SUCCESS": "Le tue impostazioni sull'altezza della casella di risposta sono state aggiornate con successo",
          "PERCENT_LABEL": "Altezza (% dell'altezza dello schermo)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Predefinito",
              "DESCRIPTION": "La casella di risposta inizia piccola e si espande man mano che scrivi."
            },
            "CUSTOM": {
              "HEADING": "Personalizzato",
              "DESCRIPTION": "La casella di risposta occupa sempre almeno la percentuale scelta dell'altezza dello schermo."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navigazione automatica alla conversazione successiva",
        "NOTE": "Passa automaticamente alla successiva conversazione aperta dopo aver risolto quella corrente",
        "UPDATE_SUCCESS": "Impostazione di navigazione automatica aggiornata con successo"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formato dell'anteprima email nell'elenco delle conversazioni",
        "NOTE": "Scegli cosa viene mostrato nell'elenco delle conversazioni per le conversazioni provenienti dalle caselle email",
        "SUBJECT": "Oggetto",
        "SUBJECT_WITH_NOTE": "Oggetto e ultimo messaggio se è una nota interna",
        "UPDATE_SUCCESS": "Impostazione dell'anteprima email aggiornata con successo"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Disabilita scorciatoie da tastiera",
        "NOTE": "Disattiva tutte le scorciatoie da tastiera nell'applicazione",
        "UPDATE_SUCCESS": "Impostazione delle scorciatoie da tastiera aggiornata con successo"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordine delle cartelle",
        "NOTE": "Personalizza l'ordine in cui le cartelle (viste personalizzate) appaiono nella barra laterale. Trascina e rilascia per riordinare.",
        "NO_FOLDERS": "Nessuna cartella personalizzata trovata. Crea cartelle per organizzare le tue conversazioni."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configurazione barra laterale",
        "NOTE": "Personalizza quali sezioni appaiono nella barra laterale delle conversazioni.",
        "SAVE_BUTTON": "Salva configurazione",
        "UPDATE_SUCCESS": "Configurazione della barra laterale aggiornata con successo",
        "UPDATE_ERROR": "Si è verificato un errore durante l'aggiornamento della configurazione della barra laterale, riprova",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Tutte le conversazioni",
          "ALL_CONVERSATIONS_DESC": "Mostra la voce di menu Tutte le conversazioni nella barra laterale",
          "INBOX": "Casella",
          "INBOX_DESC": "Mostra la casella principale con le notifiche non lette",
          "CONVERSATION_GROUPS": "Menzioni e non gestite",
          "CONVERSATION_GROUPS_DESC": "Mostra i gruppi di conversazioni menzioni e non gestite",
          "FOLDERS": "Cartelle",
          "FOLDERS_DESC": "Mostra viste personalizzate (cartelle) per conversazioni organizzate",
          "TEAMS": "Team",
          "TEAMS_DESC": "Mostra conversazioni filtrate per assegnazione al team",
          "CHANNELS": "Caselle",
          "CHANNELS_DESC": "Mostra conversazioni filtrate per casella",
          "LABELS": "Etichette",
          "LABELS_DESC": "Mostra conversazioni filtrate per etichetta"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Impostazioni telefono",
        "NOTE": "Inserisci le credenziali di accesso al tuo sistema PBX.",
        "USERNAME": "Nome utente",
        "PASSWORD": "Password",
        "SUBMIT": "Salva",
        "USERNAME_INVALID": "Il nome utente può contenere solo lettere, numeri e . _ - + — niente spazi e nessun indirizzo email.",
        "API": {
          "USERNAME_INVALID": "Il nome utente non è un nome utente SIP valido. Usa solo lettere, numeri e . _ - + — niente spazi e nessun indirizzo email.",
          "USERNAME_TAKEN": "Questo nome utente è già utilizzato da un altro agente in questo account."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Firma del messaggio personale",
        "DESCRIPTION": "Crea una firma univoca da far apparire in fondo a ogni email che invii. Puoi anche includere un'immagine inline.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Salva firma del messaggio",
        "API_ERROR": "Impossibile salvare la firma! Riprova",
        "API_SUCCESS": "Firma salvata con successo",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Firma del messaggio",
        "ERROR": "La firma del messaggio non può essere vuota",
        "PLACEHOLDER": "Inserisci qui la firma del tuo messaggio personale."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Password",
        "NOTE": "Aggiornare la tua password reimposterà i tuoi accessi in più dispositivi.",
        "BTN_TEXT": "Cambia password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token di accesso",
        "NOTE": "Questo token può essere usato se stai costruendo un'integrazione basata su API",
        "COPY": "Copia",
        "REGENERATE": "Rigenera",
        "REGENERATE_SUCCESS": "Token di accesso rigenerato con successo. Aggiorna le integrazioni che usano il vecchio token.",
        "REGENERATE_CONFIRM_TITLE": "Rigenerare il token di accesso?",
        "REGENERATE_CONFIRM_MESSAGE": "Questo invaliderà il token corrente. Qualsiasi integrazione che usa il vecchio token smetterà di funzionare."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Estensione Chrome",
        "NOTE": "Installa la nostra estensione Chrome per ricevere notifiche dettagliate sulle chiamate telefoniche in arrivo.",
        "INSTALL_BUTTON": "Installa estensione",
        "ALREADY_INSTALLED": "Estensione installata"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Avvisi audio",
        "NOTE": "Abilita gli avvisi audio nel dashboard per nuovi messaggi e conversazioni.",
        "PLAY": "Riproduci suono",
        "ALERT_TYPES": {
          "NONE": "Nessuno",
          "MINE": "Assegnate a me",
          "ALL": "Tutti",
          "ASSIGNED": "Le mie conversazioni assegnate",
          "UNASSIGNED": "Conversazioni non assegnate",
          "NOTME": "Conversazioni aperte assegnate ad altri"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Non hai selezionato alcuna opzione, non riceverai avvisi audio.",
          "ASSIGNED": "Riceverai avvisi per le conversazioni assegnate a te.",
          "UNASSIGNED": "Riceverai avvisi per tutte le conversazioni non assegnate.",
          "NOTME": "Riceverai avvisi per le conversazioni assegnate ad altri.",
          "ASSIGNED+UNASSIGNED": "Riceverai avvisi per le conversazioni assegnate a te e per quelle non assegnate.",
          "ASSIGNED+NOTME": "Riceverai avvisi per le conversazioni assegnate a te e ad altri, ma non per quelle non assegnate.",
          "NOTME+UNASSIGNED": "Riceverai avvisi per le conversazioni non assegnate e per quelle assegnate ad altri.",
          "ASSIGNED+NOTME+UNASSIGNED": "Riceverai avvisi per tutte le conversazioni."
        },
        "ALERT_TYPE": {
          "TITLE": "Eventi di avviso per le conversazioni",
          "NONE": "Nessuno",
          "ASSIGNED": "Conversazioni assegnate",
          "ALL_CONVERSATIONS": "Tutte le conversazioni"
        },
        "DEFAULT_TONE": {
          "TITLE": "Suono di avviso:"
        },
        "CONDITIONS": {
          "TITLE": "Condizioni degli avvisi:",
          "CONDITION_ONE": "Invia avvisi audio solo se la finestra del browser non è attiva",
          "CONDITION_TWO": "Invia avvisi ogni 10 secondi finché tutte le conversazioni assegnate non sono lette"
        },
        "SOUND_PERMISSION_ERROR": "La riproduzione automatica è disabilitata nel tuo browser. Per ascoltare gli avvisi automaticamente, abilita i permessi audio nelle impostazioni del browser o interagisci con la pagina.",
        "READ_MORE": "Scopri di più"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notifiche email",
        "NOTE": "Aggiorna qui le tue preferenze di notifica email",
        "CONVERSATION_ASSIGNMENT": "Invia notifiche email quando viene assegnata una conversazione a me",
        "CONVERSATION_CREATION": "Invia notifiche email quando viene creata una nuova conversazione",
        "CONVERSATION_MENTION": "Invia notifiche email quando sei menzionato in una conversazione",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Invia notifiche email quando viene creato un nuovo messaggio in una conversazione assegnata",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferenze di notifica",
        "TYPE_TITLE": "Tipo di notifica",
        "EMAIL": "Email",
        "PUSH": "Notifica push",
        "TYPES": {
          "CONVERSATION_CREATED": "Viene creata una nuova conversazione",
          "CONVERSATION_ASSIGNED": "Una conversazione ti viene assegnata",
          "CONVERSATION_MENTION": "Sei menzionato in una conversazione",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Viene creato un nuovo messaggio in una conversazione assegnata",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Viene creato un nuovo messaggio in una conversazione a cui partecipi",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Viene creato un nuovo messaggio in una conversazione senza agente disponibile",
          "SLA_MISSED_FIRST_RESPONSE": "Una conversazione supera il tempo SLA per la prima risposta",
          "SLA_MISSED_NEXT_RESPONSE": "Una conversazione supera il tempo SLA per la risposta successiva",
          "SLA_MISSED_RESOLUTION": "Una conversazione supera il tempo SLA per la risoluzione"
        },
        "BROWSER_PERMISSION": "Abilita le notifiche push nel tuo browser per poterle ricevere",
        "ALLOW_NOTIFICATION_DURING_CALL": "Consenti le notifiche push mentre sei in chiamata",
        "TEST_PUSH": "Test",
        "TESTING": "Test in corso...",
        "TEST_PUSH_DESCRIPTION": "Invia notifiche di test per verificare la tua configurazione",
        "TEST_NOTIFICATION_ERROR": "Impossibile inviare la notifica di test. Riprova.",
        "TEST_LOCAL_TITLE": "Notifica di test (locale)",
        "TEST_LOCAL_BODY": "Questa è una notifica locale del browser. Se la vedi, le notifiche del browser funzionano!"
      },
      "API": {
        "UPDATE_SUCCESS": "Le preferenze di notifica sono state aggiornate con successo",
        "UPDATE_ERROR": "Si è verificato un errore durante l'aggiornamento delle preferenze, riprova"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notifiche push",
        "NOTE": "Aggiorna qui le tue preferenze per le notifiche push",
        "CONVERSATION_ASSIGNMENT": "Invia notifiche push quando una conversazione ti viene assegnata",
        "CONVERSATION_CREATION": "Invia notifiche push quando viene creata una nuova conversazione",
        "CONVERSATION_MENTION": "Invia notifiche push quando sei menzionato in una conversazione",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Invia notifiche push quando viene creato un nuovo messaggio in una conversazione assegnata",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Invia notifiche push quando viene creato un nuovo messaggio in una conversazione a cui partecipi",
        "HAS_ENABLED_PUSH": "Hai abilitato le notifiche push per questo browser.",
        "REQUEST_PUSH": "Abilita notifiche push",
        "SLA_MISSED_FIRST_RESPONSE": "Invia notifiche push quando una conversazione supera il tempo SLA per la prima risposta",
        "SLA_MISSED_NEXT_RESPONSE": "Invia notifiche push quando una conversazione supera il tempo SLA per la risposta successiva",
        "SLA_MISSED_RESOLUTION": "Invia notifiche push quando una conversazione supera il tempo SLA per la risoluzione"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Immagine del profilo"
      },
      "NAME": {
        "LABEL": "Il tuo nome completo",
        "ERROR": "Per favore inserisci il nome completo",
        "PLACEHOLDER": "Per favore inserisci il nome completo"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nome visualizzato",
        "ERROR": "Inserisci un nome di visualizzazione valido",
        "PLACEHOLDER": "Inserisci un nome di visualizzazione, questo verrà visualizzato nelle conversazioni"
      },
      "POSITION": {
        "LABEL": "Posizione",
        "ERROR": "Inserisci una posizione valida",
        "PLACEHOLDER": "Inserisci la tua posizione"
      },
      "CUSTOM_LINE": {
        "LABEL": "Riga personalizzata",
        "ERROR": "Inserisci una riga personalizzata valida",
        "PLACEHOLDER": "Inserisci la tua riga personalizzata"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilità",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Occupato",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL": {
        "LABEL": "Il tuo indirizzo email",
        "ERROR": "Inserisci un indirizzo email valido",
        "PLACEHOLDER": "Inserisci il tuo indirizzo email, che verrà visualizzato nelle conversazioni"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Password attuale",
        "ERROR": "Inserisci la password attuale",
        "PLACEHOLDER": "Inserisci la password attuale"
      },
      "PASSWORD": {
        "LABEL": "Nuova password",
        "ERROR": "Inserisci una password di lunghezza 6 o più",
        "PLACEHOLDER": "Inserisci una nuova password"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Conferma nuova password",
        "ERROR": "La password di conferma deve corrispondere alla password",
        "PLACEHOLDER": "Inserisci nuovamente la nuova password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Cambia stato disponibilità",
    "CHANGE_ACCOUNTS": "Cambia account",
    "SWITCH_ACCOUNT": "Cambia account",
    "CONTACT_SUPPORT": "Contatta il supporto",
    "REPORT_BUG": "Segnala un bug",
    "SELECTOR_SUBTITLE": "Seleziona un account dall'elenco seguente",
    "PROFILE_SETTINGS": "Impostazioni profilo",
    "KEYBOARD_SHORTCUTS": "Scorciatoie da tastiera",
    "APPEARANCE": "Cambia aspetto",
    "SUPER_ADMIN_CONSOLE": "Console SuperAdmin",
    "DOCS": "Leggi la documentazione",
    "LOGOUT": "Disconnetti"
  },
  "BUG_REPORT": {
    "TITLE": "Segnala un bug",
    "DESCRIPTION_LABEL": "Descrizione del problema",
    "DESCRIPTION_PLACEHOLDER": "Descrivi il problema che hai riscontrato...",
    "SUBMIT": "Invia segnalazione",
    "SUBMITTING": "Invio in corso...",
    "CANCEL": "Annulla",
    "SUCCESS": "Segnalazione di bug inviata con successo. Grazie!",
    "ERROR": "Impossibile inviare la segnalazione di bug. Riprova.",
    "VALIDATION_ERROR": "Descrivi il problema prima di inviare"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "giorni di prova rimanenti.",
    "TRAIL_BUTTON": "Acquista ora",
    "DELETED_USER": "Utente eliminato",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account sospeso",
      "MESSAGE": "Il tuo account è sospeso. Contatta il team di supporto per ulteriori informazioni."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copia",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Codice copiato negli appunti correttamente"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostra di più",
      "SHOW_LESS": "Mostra meno"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Scarica",
      "UPLOADING": "Caricamento...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Questa storia non è più disponibile.",
      "RECORDING_UNAVAILABLE": "Questa registrazione non è più disponibile.",
      "DELETE_RECORDING": {
        "BUTTON": "Elimina registrazione della chiamata",
        "TITLE": "Eliminare la registrazione della chiamata?",
        "DESCRIPTION": "Tutte le registrazioni di questa chiamata verranno eliminate definitivamente dal sistema telefonico e non potranno essere ripristinate. La trascrizione e il riepilogo della chiamata rimangono.",
        "CONFIRM": "Elimina",
        "SUCCESS": "Registrazione della chiamata eliminata",
        "ERROR": "Impossibile eliminare la registrazione della chiamata. Riprova."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Invia"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Questa immagine non è più disponibile.",
      "LOADING_FAILED": "Caricamento non riuscito"
    }
  },
  "CONFIRM_EMAIL": "Verifica...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Aggiungi Casella"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Visualizzazione attuale:",
    "SWITCH": "Scambia",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversazioni",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Tutte le conversazioni",
    "MENTIONED_CONVERSATIONS": "Menzioni",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Non partecipate",
    "REPORTS": "Segnalazioni",
    "SETTINGS": "Impostazioni",
    "CONTACTS": "Contatti",
    "DATA_ASSISTANT": "Assistente Dati",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "Modelli WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Posta",
    "NOTIFICATIONS": "Notifiche",
    "CANNED_RESPONSES": "Risposte predefinite",
    "INTEGRATIONS": "Integrazioni",
    "PROFILE_SETTINGS": "Impostazioni profilo",
    "ACCOUNT_SETTINGS": "Impostazioni account",
    "APPLICATIONS": "Applicazioni",
    "LABELS": "Etichette",
    "CUSTOM_ATTRIBUTES": "Attributi personalizzati",
    "AUTOMATION": "Automazione",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Fatturazione",
    "CUSTOM_VIEWS_FOLDER": "Cartelle",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Tutti i contatti",
    "TAGGED_WITH": "Etichettato con",
    "NEW_LABEL": "Nuova etichetta",
    "NEW_TEAM": "Nuovo team",
    "NEW_INBOX": "Nuova casella di posta",
    "REPORTS_CONVERSATION": "Conversazioni",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campagne",
    "ONGOING": "In corso",
    "ONE_OFF": "Uno fuori",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Etichette",
    "REPORTS_INBOX": "Posta",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefono",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Panoramica",
    "WALLBOARD_QUEUES": "Code",
    "WALLBOARD_AGENTS": "Panoramica agenti",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Report",
    "NO_WAITING_CALLERS": "nessun chiamante in attesa",
    "WAITING_CALLERS": "{count} chiamanti in attesa",
    "SET_AVAILABILITY_TITLE": "Imposta te stesso come",
    "SET_YOUR_AVAILABILITY": "Imposta la tua disponibilità",
    "AVAILABILITY_IMPERSONATING": "Bloccato durante l'accesso come questo utente",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Nuova conversazione",
    "DRAFT": "Bozza",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Panoramica",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categorie",
      "LOCALES": "Lingue",
      "SETTINGS": "Impostazioni",
      "DICTIONARY": "Dizionario"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Leggi i documenti"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Domini e contatti bloccati",
    "DESCRIPTION": "Elenco dei domini email bloccati per questo account.",
    "NO_BLOCKED_DOMAINS": "Nessun dominio bloccato trovato.",
    "BLOCKED_CONTACTS_BTN": "Contatti bloccati"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Fatturazione",
    "DESCRIPTION": "Gestisci qui il tuo abbonamento, aggiorna il tuo piano e ottieni di più per il tuo team.",
    "CURRENT_PLAN": {
      "TITLE": "Piano attuale",
      "PLAN_NOTE": "Sei attualmente abbonato al piano **{plan}** con **{quantity}** licenze",
      "SEAT_COUNT": "Numero di posti",
      "RENEWS_ON": "Si rinnova il"
    },
    "VIEW_PRICING": "Visualizza i prezzi",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gestisci il tuo abbonamento",
      "DESCRIPTION": "Visualizza le tue fatture precedenti, modifica i tuoi dati di fatturazione o annulla il tuo abbonamento.",
      "BUTTON_TXT": "Vai al portale di fatturazione"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Gestisci l'utilizzo e i crediti per Captain AI.",
      "BUTTON_TXT": "Acquista più crediti",
      "DOCUMENTS": "Documenti",
      "RESPONSES": "Risposte",
      "UPGRADE": "Captain non è disponibile nel piano gratuito. Passa a un piano superiore per accedere agli assistenti, al copilot e ad altre funzionalità."
    },
    "CHAT_WITH_US": {
      "TITLE": "Hai bisogno di aiuto?",
      "DESCRIPTION": "Hai qualche problema di fatturazione? Siamo qui per aiutarti.",
      "BUTTON_TXT": "Chatta con noi"
    },
    "NO_BILLING_USER": "Il tuo account di fatturazione è in fase di configurazione. Per favore aggiorna la pagina e riprova."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! Non abbiamo trovato alcun account. Si prega di creare un nuovo account per continuare.",
    "NEW_ACCOUNT": "Nuovo account",
    "SELECTOR_SUBTITLE": "Crea un nuovo account",
    "API": {
      "SUCCESS_MESSAGE": "Account creato con successo",
      "EXIST_MESSAGE": "Account già esistente",
      "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome azienda",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Invia",
      "CANCEL": "Annulla"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Apri conversazione",
      "RESOLVE_AND_NEXT": "Risolvi e vai alla prossima",
      "NAVIGATE_DROPDOWN": "Naviga con gli elementi a discesa",
      "RESOLVE_CONVERSATION": "Risolvi la conversazione",
      "GO_TO_CONVERSATION_DASHBOARD": "Vai alla dashboard Conversazioni",
      "ADD_ATTACHMENT": "Aggiungi allegato",
      "GO_TO_CONTACTS_DASHBOARD": "Vai alla dashboard Contatti",
      "TOGGLE_SIDEBAR": "Attiva/Disattiva barra laterale",
      "GO_TO_REPORTS_SIDEBAR": "Vai alla barra laterale dei rapporti",
      "MOVE_TO_NEXT_TAB": "Vai alla scheda successiva nell'elenco delle conversazioni",
      "GO_TO_SETTINGS": "Vai alle impostazioni",
      "SWITCH_TO_PRIVATE_NOTE": "Passa alle note private",
      "SWITCH_TO_REPLY": "Passa a Risposta",
      "TOGGLE_SNOOZE_DROPDOWN": "Attiva/Disattiva sospensione a discesa",
      "AI_ASSIST_MENU": "Assistenza AI",
      "AI_ASSIST_GRAMMAR": "Correggi grammatica",
      "AI_ASSIST_UNIFY_LANG": "Unifica lingua del messaggio"
    }
  }
}
